import * as CookieConsent from 'vanilla-cookieconsent';
/**
 * All config. options available here:
 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
 */

CookieConsent.run({
    guiOptions: {
        consentModal: {
            layout: 'box',
            position: 'bottom left',
            equalWeightButtons: true,
            flipButtons: false,
        },
        preferencesModal: {
            layout: 'box',
            position: 'right',
            equalWeightButtons: true,
            flipButtons: false,
        },
    },
    categories: {
        necessary: {
            readOnly: true,
        },
        analytics: {},
    },
    language: {
        default: 'fr-CA',
        autoDetect: 'document',
        translations: {
            'en-CA': {
                consentModal: {
                    description: 'We place great importance on the protection of your privacy. Our data collection practices are governed by a transparent Privacy Policy. By browsing this site, you consent to the use of cookies and other technologies to enhance your experience and analyze site usage. You have the option to manage your preferences by customizing site or browser settings. You can also adjust your choice at any time by clicking the "Manage Cookie Preferences" link located in the footer. Please refer to our <a href="/vie-privee" class="cc-link">Privacy Policy</a> for more information.',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    showPreferencesBtn: 'Manage preferences',
                },
                preferencesModal: {
                    title: 'Cookie preferences',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    savePreferencesBtn: 'Save preferences',
                    closeIconLabel: 'Close modal',
                    serviceCounterLabel: 'Service|Services',
                    sections: [
                        {
                            title: null,
                            description: 'We use cookies to help you navigate efficiently and perform certain functions. Detailed information about all cookies can be found under each consent category below. <br><br>You can choose to enable or disable these cookies in whole or in part. However, please note that disabling some of them may impact your browsing experience.',
                        },
                        {
                            title: 'Optional cookies',
                            description: 'We use third-party cookies to analyze your usage of the site. Analytics cookies provide information about visitor interactions, including the number, bounce rate, traffic source, etc. These cookies will only be stored in your browser with your prior consent.',
                            linkedCategory: 'analytics',
                            cookieTable: {
                                headers: {
                                    name: 'Nom',
                                    description: 'description',
                                    domain: 'Domaine',
                                    expiration: 'Expiration',
                                },
                                body: [
                                    {
                                        name: '_fbp',
                                        description: 'This cookie is set by Facebook to deliver advertisement when they are on Facebook or a digital platform powered by Facebook advertising after visiting this website.',
                                        domain: 'facebook.com',
                                        expiration: '3 months',
                                    },
                                    {
                                        name: '_ga',
                                        description: 'This cookie is installed by Google Analytics. The cookie is used to calculate visitor, session, campaign data and keep track of site usage for the site\'s analytics report. The cookies store information anonymously and assigns a randomly generated number to identify unique visitors.',
                                        domain: 'google.com',
                                        expiration: '2 years',
                                    },
                                    {
                                        name: '_gat',
                                        description: 'This cookie is used by Google Analytics to throttle request rate.',
                                        domain: 'google.com',
                                        expiration: '1 minute',
                                    },
                                    {
                                        name: '_gcl_*',
                                        description: 'The cookie is used by Google Tag Manager to track and store conversions.',
                                        domain: 'google.com',
                                        expiration: '3 months',
                                    },
                                    {
                                        name: '_gid',
                                        description: 'This cookie is installed by Google Analytics. The cookie is used to store information of how visitors use a website and helps in creating an analytics report of how the website is doing. The data collected includes the number of visitors, the source where they have come from, and the pages visited in an anonymous form.',
                                        domain: 'google.com',
                                        expiration: '1 day',
                                    },
                                    {
                                        name: 'calltrk_*',
                                        description: 'This cookie is used by CallRail to calculate data related to visitors, sessions, and campaigns. The cookie allows tracking of site usage for the site\'s analysis report. It stores information anonymously and assigns a randomly generated number to identify unique visitors.',
                                        domain: 'callrail.com',
                                        expiration: '1 year',
                                    },
                                    {
                                        name: '1P_JAR',
                                        description: 'This cookie collects statistics on website usage and measures conversions. A conversion occurs, for example, when a user becomes a buyer. The cookie is also used to display relevant ads to users. Furthermore, the cookie can be used to prevent a user from seeing the same ad more than once.',
                                        domain: 'google.com',
                                        expiration: '1 month',
                                    },
                                    {
                                        name: 'IDE',
                                        description: 'This cookie is used to show Google ads on non-Google sites.',
                                        domain: 'google.com',
                                        expiration: '2 years',
                                    },
                                    {
                                        name: 'NID',
                                        description: 'This cookie is used to show Google ads in Google services for signed-out users.',
                                        domain: 'google.com',
                                        expiration: '6 months',
                                    },
                                    {
                                        name: 'ar_debug',
                                        description: 'This cookie is used by Google Ads to debug advertisements.',
                                        domain: 'google.com',
                                        expiration: '1 month',
                                    },
                                    {
                                        name: 'receive-cookie-deprecation',
                                        description: 'This cookie is used to display Google advertisements on non-Google websites.',
                                        domain: 'google.com',
                                        expiration: '6 months',
                                    },
                                ],
                            },
                        },
                        {
                            title: 'More information',
                            description: 'For any query in relation to my policy on cookies and your choices, please <a class="cc__link" href="/en/privacy-policy/">contact me</a>.',
                        },
                    ],
                },
            },
            'fr-CA': {
                consentModal: {
                    description: 'Nous attachons une grande importance à la protection de votre vie privée. Nos pratiques de collecte de données sont régies par une Politique de confidentialité transparente. En naviguant sur ce site, vous consentez à l\'utilisation de témoins (cookies) et d\'autres technologies pour améliorer votre expérience et analyser l\'utilisation du site. Vous avez la possibilité de gérer vos préférences en personnalisant les paramètres du site ou de votre navigateur. Vous pouvez également ajuster votre choix à tout moment en cliquant sur le lien "Gestion des témoins de navigation\', situé dans le pied de page. Consultez notre <a href="/vie-privee" class="cc-link">Politique de confidentialité</a> pour plus d\'informations.',
                    acceptAllBtn: 'Tout accepter',
                    acceptNecessaryBtn: 'Tout rejeter',
                    showPreferencesBtn: 'Gérer les préférences',
                },
                preferencesModal: {
                    title: 'Personnaliser vos préférences en matière de consentement',
                    acceptAllBtn: 'Tout accepter',
                    acceptNecessaryBtn: 'Tout rejeter',
                    savePreferencesBtn: 'Sauvegarder les préférences',
                    closeIconLabel: 'Fermer la modale',
                    serviceCounterLabel: 'Services',
                    sections: [
                        {
                            title: null,
                            description: 'Nous utilisons des témoins (cookies) pour vous aider à naviguer efficacement et à exécuter certaines fonctionnalités. Vous trouverez des informations détaillées sur tous les cookies sous chaque catégorie de consentement ci-dessous. <br><br>Vous pouvez choisir d\'activer tout ou de désactiver en partie ces témoins. Toutefois, veuillez noter que la désactivation de certains d\'entre eux pourrait avoir un impact sur votre expérience de navigation. ',
                        },
                        {
                            title: 'Témoins facultatifs',
                            description: 'Nous utilisons des témoins tiers pour analyser votre utilisation du site. Les témoins facultatifs fournissent des informations sur les interactions des visiteurs, notamment le nombre, le taux de rebond, la source de trafic, etc. Ces témoins ne seront stockés dans votre navigateur qu\'avec votre consentement préalable.',
                            linkedCategory: 'analytics',
                            cookieTable: {
                                headers: {
                                    name: 'Nom',
                                    description: 'description',
                                    domain: 'Domaine',
                                    expiration: 'Expiration',
                                },
                                body: [
                                    {
                                        name: '_fbp',
                                        description: 'Ce témoin est défini par Facebook pour diffuser des publicités lorsque les utilisateurs se trouvent sur Facebook ou sur une plateforme numérique alimentée par la publicité Facebook, après avoir visité ce site web.',
                                        domain: 'facebook.com',
                                        expiration: '3 mois',
                                    },
                                    {
                                        name: '_ga',
                                        description: 'Google Analytics utilise ce témoin pour calculer les données relatives aux visiteurs, aux sessions et aux campagnes. Le témoin permet de suivre l\'utilisation du site pour le rapport d\'analyse du site. Il stocke les informations de manière anonyme et attribue un numéro généré de manière aléatoire pour identifier les visiteurs uniques.',
                                        domain: 'google.com',
                                        expiration: '2 ans',
                                    },
                                    {
                                        name: '_gat',
                                        description: 'Ce témoin est utilisé par Google Analytics pour réguler le taux de requêtes.',
                                        domain: 'google.com',
                                        expiration: '1 minute',
                                    },
                                    {
                                        name: '_gcl_*',
                                        description: 'Ce témoin est utilisé par Google Tag Manager pour suivre et stocker les conversions.',
                                        domain: 'google.com',
                                        expiration: '3 mois',
                                    },
                                    {
                                        name: '_gid',
                                        description: 'Ce témoin est installé par Google Analytics. Il sert à stocker des informations sur la façon dont les visiteurs utilisent un site web et aide à créer un rapport analytique sur les performances du site. Les données recueillies incluent le nombre de visiteurs, leur source d\'origine, ainsi que les pages visitées, le tout de manière anonyme.',
                                        domain: 'google.com',
                                        expiration: '1 jour',
                                    },
                                    {
                                        name: 'calltrk_*',
                                        description: 'Ce témoin est utilisé par CallRail pour calculer les données relatives aux visiteurs, aux sessions et aux campagnes. Ce témoin permet de suivre l’utilisation du site pour le rapport d’analyse. Il stocke les informations de manière anonyme et attribue un numéro généré de manière aléatoire pour identifier les visiteurs uniques.',
                                        domain: 'callrail.com',
                                        expiration: '1 an',
                                    },
                                    {
                                        name: '1P_JAR',
                                        description: 'Ce témoin collecte des statistiques sur l\'utilisation du site web et mesure les conversions. Une conversion se produit, par exemple, lorsqu\'un utilisateur devient un acheteur. Le témoin est également utilisé pour afficher des publicités pertinentes aux utilisateurs. De plus, le témoin peut être utilisé pour éviter qu\'un utilisateur ne voie la même publicité plus d\'une fois.',
                                        domain: 'google.com',
                                        expiration: '1 mois',
                                    },
                                    {
                                        name: 'IDE',
                                        description: 'Ce témoin est utilisé pour afficher des publicités Google sur des sites non-Google.',
                                        domain: 'google.com',
                                        expiration: '2 ans',
                                    },
                                    {
                                        name: 'NID',
                                        description: 'Ce témoin est utilisé pour afficher des publicités Google dans les services Google pour les utilisateurs non connectés.',
                                        domain: 'google.com',
                                        expiration: '6 mois',
                                    },
                                    {
                                        name: 'ar_debug',
                                        description: 'Ce témoin est utilisée par Google Ads pour déboguer les publicités.',
                                        domain: 'google.com',
                                        expiration: '1 mois',
                                    },
                                    {
                                        name: 'receive-cookie-deprecation',
                                        description: 'Ce témoin est utilisée pour afficher des publicités Google sur des sites qui ne sont pas de Google.',
                                        domain: 'google.com',
                                        expiration: '6 mois',
                                    },
                                ],
                            },
                        },
                        {
                            title: 'Pour en savoir plus',
                            description: 'Pour plus d\'information, consultez notre page sur la <a class="cc-link" href="/confidentialite/">confidentialité</a>.',
                        },
                    ],
                },
            },
        },
    },
});
